/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetNewsList200ResponseDataArticlesInnerThumbnailInner } from './GetNewsList200ResponseDataArticlesInnerThumbnailInner'
import {
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSON,
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSONTyped,
  GetNewsList200ResponseDataArticlesInnerThumbnailInnerToJSON,
} from './GetNewsList200ResponseDataArticlesInnerThumbnailInner'
import type { GetNewsItem200ResponseDataRelevantPostsInner } from './GetNewsItem200ResponseDataRelevantPostsInner'
import {
  GetNewsItem200ResponseDataRelevantPostsInnerFromJSON,
  GetNewsItem200ResponseDataRelevantPostsInnerFromJSONTyped,
  GetNewsItem200ResponseDataRelevantPostsInnerToJSON,
} from './GetNewsItem200ResponseDataRelevantPostsInner'
import type { GetNewsItem200ResponseDataConstructorInner } from './GetNewsItem200ResponseDataConstructorInner'
import {
  GetNewsItem200ResponseDataConstructorInnerFromJSON,
  GetNewsItem200ResponseDataConstructorInnerFromJSONTyped,
  GetNewsItem200ResponseDataConstructorInnerToJSON,
} from './GetNewsItem200ResponseDataConstructorInner'

/**
 *
 * @export
 * @interface GetNewsItem200ResponseData
 */
export interface GetNewsItem200ResponseData {
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseData
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseData
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseData
   */
  category?: string | null
  /**
   *
   * @type {Date}
   * @memberof GetNewsItem200ResponseData
   */
  publishedAt?: Date | null
  /**
   * Время чтения, например «5 минут»
   * @type {string}
   * @memberof GetNewsItem200ResponseData
   */
  readingTime?: string | null
  /**
   * Конверсии обложки (оригинал + pc/tablet/mobile, по убыванию площади)
   * @type {Array<GetNewsList200ResponseDataArticlesInnerThumbnailInner>}
   * @memberof GetNewsItem200ResponseData
   */
  thumbnail?: Array<GetNewsList200ResponseDataArticlesInnerThumbnailInner>
  /**
   * Блоки контента конструктора: text_block (data.content — HTML), media_block (data — конверсии изображения), table_block, blockquote_block, frame_text
   * @type {Array<GetNewsItem200ResponseDataConstructorInner>}
   * @memberof GetNewsItem200ResponseData
   */
  constructor?: Array<GetNewsItem200ResponseDataConstructorInner>
  /**
   * Релевантные новости (ручной выбор, иначе следующие по дате с wrap-around)
   * @type {Array<GetNewsItem200ResponseDataRelevantPostsInner>}
   * @memberof GetNewsItem200ResponseData
   */
  relevantPosts?: Array<GetNewsItem200ResponseDataRelevantPostsInner>
}

/**
 * Check if a given object implements the GetNewsItem200ResponseData interface.
 */
export function instanceOfGetNewsItem200ResponseData(
  value: object
): value is GetNewsItem200ResponseData {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  return true
}

export function GetNewsItem200ResponseDataFromJSON(
  json: any
): GetNewsItem200ResponseData {
  return GetNewsItem200ResponseDataFromJSONTyped(json, false)
}

export function GetNewsItem200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsItem200ResponseData {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    category: json['category'] == null ? undefined : json['category'],
    publishedAt:
      json['publishedAt'] == null ? undefined : new Date(json['publishedAt']),
    readingTime: json['readingTime'] == null ? undefined : json['readingTime'],
    thumbnail:
      json['thumbnail'] == null
        ? undefined
        : (json['thumbnail'] as Array<any>).map(
            GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSON
          ),
    constructor:
      json['constructor'] == null
        ? undefined
        : (json['constructor'] as Array<any>).map(
            GetNewsItem200ResponseDataConstructorInnerFromJSON
          ),
    relevantPosts:
      json['relevantPosts'] == null
        ? undefined
        : (json['relevantPosts'] as Array<any>).map(
            GetNewsItem200ResponseDataRelevantPostsInnerFromJSON
          ),
  }
}

export function GetNewsItem200ResponseDataToJSON(
  value?: GetNewsItem200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    category: value['category'],
    publishedAt:
      value['publishedAt'] == null
        ? undefined
        : (value['publishedAt'] as any).toISOString(),
    readingTime: value['readingTime'],
    thumbnail:
      value['thumbnail'] == null
        ? undefined
        : (value['thumbnail'] as Array<any>).map(
            GetNewsList200ResponseDataArticlesInnerThumbnailInnerToJSON
          ),
    constructor:
      value['constructor'] == null
        ? undefined
        : (value['constructor'] as Array<any>).map(
            GetNewsItem200ResponseDataConstructorInnerToJSON
          ),
    relevantPosts:
      value['relevantPosts'] == null
        ? undefined
        : (value['relevantPosts'] as Array<any>).map(
            GetNewsItem200ResponseDataRelevantPostsInnerToJSON
          ),
  }
}
